<template>
<modal 
    component-name="modal-video" 
    :is-open="isOpen" 
    transition="slide-from-bottom"
    @close="emit('close')" 
    @open="emit('open')" 
    data-skin="skin-dark"
>
    <div
      ref="tpl_wrapper"
      class="flex flex-col justify-center items-center w-full h-[calc(100vh-66px)] supports-[height:100dvh]:h-[calc(100dvh-66px)]"
    >
      <div 
        class="w-full"
        :style="{
          maxWidth: `${playerMaxHeight}px`
        }"
      >
        <vimeo
          class="w-full h-full" 
          :video-url="videoUrl" 
          :autoplay="true" 
          :pause-when-offscreen="false"
          :on-ended="() => emit('close')"
        />
      </div>
    </div>
    
</modal>
</template>

<script setup>
const props = defineProps({
  isOpen: {
    type: Boolean,
    reqired: false,
    default: false,
  },
  videoUrl: {
    type: String,
    reqired: true,
  },
});

const tpl_wrapper = templateRef("tpl_wrapper");
const emit = defineEmits(["open", "close"]);
const { height } = useElementSize(tpl_wrapper);
const playerMaxHeight = computed(() => {
  if (!tpl_wrapper.value) {
    return;
  }
  return parseInt((height.value * 16) / 9);
});
</script>